import { ContractsIngestionRuntimeInputDto } from '../../types';
import { InputBaseModel, NodeBaseModel } from '..';

export default class InputModel extends InputBaseModel {
    constructor(node: NodeBaseModel, data: ContractsIngestionRuntimeInputDto) {
        super(node, data);
    }

    get formattedValue(): unknown {
        return this.value;
    }
}
